/*
  initial component generated by: https://github.com/pmndrs/gltfjsx
*/

import * as THREE from "three";
import React, { FunctionComponent, useEffect, useRef } from "react";
import { useGLTF } from "@react-three/drei";

import { GLTF } from "three/examples/jsm/loaders/GLTFLoader";
import { IBodypart } from "./bodypart";
import { BLOOD_PATH, preloadGLTFAsset } from "../3d-models";

type GLTFResult = GLTF & {
  nodes: {
    Cardiovascular_Final_1: THREE.Mesh;
  };
  materials: {
    BloodTexture: THREE.MeshStandardMaterial;
  };
};

export const Blood: FunctionComponent<IBodypart> = (props) => {
  const { color } = props;
  const group = useRef<THREE.Group>();
  const { nodes, materials } = useGLTF(BLOOD_PATH) as GLTFResult;

  useEffect(() => {
    materials.BloodTexture.color = new THREE.Color(color);
  }, [materials, color]);

  return (
    <group ref={group} {...props} dispose={null}>
      <group rotation={[-Math.PI / 2, 0, 0]} scale={[100, 100, 100]}>
        <mesh material={materials.BloodTexture} geometry={nodes.Cardiovascular_Final_1.geometry} />
      </group>
    </group>
  );
};

preloadGLTFAsset(BLOOD_PATH);
